"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarCell = CalendarCell;
var _react = _interopRequireWildcard(require("react"));
var _calendar = require("@react-aria/calendar");
var _Calendar = require("./Calendar.styled");
var _date = require("@internationalized/date");
var _Text = _interopRequireDefault(require("../../../text/Text"));
var _InnerButton = require("../../buttons/InnerButton");
var _jsxRuntime = require("react/jsx-runtime");
function getTextColor(isSelectionStart, isSelectionEnd, isDisabled, isUnavailable) {
  return isSelectionStart || isSelectionEnd ? 'white' : isDisabled || isUnavailable ? 'disabled' : 'default';
}
function CalendarCell(_ref) {
  var state = _ref.state,
    date = _ref.date,
    currentMonth = _ref.currentMonth,
    highlight = _ref.highlight;
  var ref = (0, _react.useRef)();
  var _ref2 = (0, _calendar.useCalendarCell)({
      date: date
    }, state, ref),
    cellProps = _ref2.cellProps,
    buttonProps = _ref2.buttonProps,
    isSelected = _ref2.isSelected,
    isDisabled = _ref2.isDisabled,
    isUnavailable = _ref2.isUnavailable,
    formattedDate = _ref2.formattedDate;
  var customProps = {
    hidden: !(0, _date.isSameMonth)(currentMonth, date),
    isSelectionStart: state.highlightedRange ? (0, _date.isSameDay)(date, state.highlightedRange.start) : isSelected,
    isSelectionEnd: state.highlightedRange ? (0, _date.isSameDay)(date, state.highlightedRange.end) : isSelected,
    isSelected: isSelected,
    isDisabled: isDisabled,
    isUnavailable: isUnavailable,
    highlight: highlight
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("td", _objectSpread({}, cellProps, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Calendar.CalendarCellWrapper, _objectSpread({}, customProps, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerButton.NonVisualButton, _objectSpread({
        hidden: isDisabled,
        disabled: isDisabled
      }, customProps, buttonProps, {
        ref: ref,
        "data-cy": 'date-select-button',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          color: getTextColor(customProps.isSelectionStart, customProps.isSelectionEnd, customProps.isDisabled, customProps.isUnavailable),
          children: formattedDate
        })
      })), highlight && /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 200 200",
        fill: "none",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
          cx: "100",
          cy: "100",
          r: "95",
          strokeWidth: "5"
        })
      })]
    }))
  }));
}